


import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from '../loader/Loader';
const MaterialRejectionReportModal = ({ show, handleClose, rejectionReportId }) => {
    const [loading,setLoading]=useState(false)
    const [rejectionReport, setRejectionReport] = useState([])
    useEffect(() => {
        if (show && rejectionReportId) {
            fetchMaintenanceDetails(rejectionReportId);
        }
    }, [show, rejectionReportId]);

    const fetchMaintenanceDetails = async (id) => {
        const token = getAuthToken();
        if (!token) return;
        try {
            setLoading(true)
            const response = await axios?.get(`${config?.API}/supervisor/materialrejection/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const data = response?.data || null;
            setRejectionReport(data);
        } catch (err) {
            console.error("Error fetching RejectionReport:", err.message);
            setRejectionReport(null);
        }finally {
            setLoading(false)
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className='font_family'>
{
    loading ?(
        <Loader/>
    ):(
         <Modal.Body className='p-5'>
                <strong className='fs-4'>Material Rejection Report</strong>
                {/* Material Info */}
                <div className="p-3 mb-4 bg-light mt-4">
                    <Row>
                        <strong className='mb-2'>Material Information</strong>
                        <Col><strong>Material Name:</strong> {rejectionReport?.material_rejection?.material_master?.material_name}</Col>
                        <Col><strong>Material ID:</strong>{rejectionReport?.material_rejection?.material_master?.material_code}</Col>
                    </Row>
                    <Row className="mt-2">
                        <Col><strong>Qty Wasted:</strong> {rejectionReport?.material_rejection?.material_master?.quantity_in_stock} {rejectionReport?.material_rejection?.material_master?.unit_of_measurement}</Col>

                        <Col><strong>Date of Wastage:</strong>
                            {rejectionReport?.material_rejection?.material_master?.created_at
                                ? new Date(rejectionReport?.material_rejection?.material_master?.created_at).toLocaleDateString("en-GB")
                                : ""}
                        </Col>

                    </Row>
                    {/* <Row>
                        <Col></Col>
                        <Col><strong>Vendor:</strong> xyz_ent</Col>
                    </Row> */}
                </div>

                {/* Quantity Wasted */}
                <Row className="mb-3">
                    <Col md={3}>
                        <Form.Label><strong>Quantity Wasted</strong></Form.Label>
                    </Col>
                    <Col md={3}>
                        <div className="d-flex align-items-center">

                            <Form.Control
                                value={rejectionReport?.material_rejection?.material_master?.quantity_in_stock}
                                readOnly
                            />
                            <span className="ms-2">{rejectionReport?.material_rejection?.material_master?.unit_of_measurement}</span>
                        </div>
                    </Col>
                </Row>

                {/* Wastage Reason */}
                <Row className="mb-3">
                    <Col md={3}>
                        <Form.Label><strong>Wastage Reason</strong></Form.Label>
                    </Col>
                    <Col md={3}>
                        <div className="border rounded p-1 bg-white">{rejectionReport?.material_rejection?.reason}</div>
                    </Col>
                </Row>

                {/* Notes */}
                <Row>

                    <Col md={2}> <Form.Label><strong>Notes</strong></Form.Label></Col>
                    <Col md={10}><Form.Control
                        as="textarea"
                        rows={3}
                        value={rejectionReport?.material_rejection?.reason ?? ""}
                        readOnly
                    />
                    </Col>
                </Row>
            </Modal.Body>
    )
}
            <Modal.Footer className='border-0'>
                <Button variant="dark" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MaterialRejectionReportModal;